import React from "react"
import Utils from "../../utils/node.utils"
import { StaticQuery, graphql } from "gatsby"

import StaticPage from "../../components/StaticPage/StaticPage"
import {
  createOverlay,
  createContentList,
} from "../../contentfunctions/privacy.js"

import Carousel1 from "../../images/privacy/privacy-policy-min.jpeg"

const PrivacyPage = ({ location }) => {
  Utils.NavigateToBrowserLanguage("es", "/privacy", location.state)
  return (
    <StaticQuery
      query={pageQuery}
      render={data => {
        const commonContentMap = Utils.ContentListToMap(
          data.commonContent.item.content
        )
        const contentMap = Utils.ContentListToMap(
          data.privacyContent.item.content
        )
        const img = {
          src: Carousel1,
          altText: contentMap.seo_title.value,
          caption: contentMap.seo_description.value,
        }
        return (
          <StaticPage
            title={contentMap.seo_title.value}
            description={contentMap.seo_description.value}
            img={img}
            originPage="privacy"
            language="es"
            location={location}
            contentMap={contentMap}
            commonContentMap={commonContentMap}
            breadCrumbs={["menu_home", "menu_privacy"]}
            createContentFun={createContentList}
            createOverlayFun={createOverlay}
            keywords={Utils.GetKeywordsFromTags(data.privacyContent.item.tags)}
          />
        )
      }}
    />
  )
}

export default PrivacyPage

const pageQuery = graphql`
  {
    privacyContent: privacyContentEses {
      item {
        key
        tags {
          content {
            key
            value
          }
        }
        content {
          key
          value
        }
      }
    }

    commonContent: commonContentEses {
      item {
        key
        content {
          key
          value
        }
      }
    }
  }
`
